import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { apiRequest } from '@/shared/api'
import { TaskListItemSchema, TaskReadSchema, TaskSchema } from '../model/types'

export const taskKeys = {
  byProject: (projectId: string) => ['task', 'project', projectId] as const,
  // Глобальный список один — ключ и префикс инвалидации совпадают.
  lists: ['task', 'list'] as const,
  detail: (id: string) => ['task', 'detail', id] as const,
}

export function projectTasksQueryOptions(projectId: string) {
  return queryOptions({
    queryKey: taskKeys.byProject(projectId),
    queryFn: async () => {
      // Project-scoped листинг — конверт {data} (не курсорный).
      const body = await apiRequest<{ data: unknown[] }>({
        method: 'GET',
        url: `/projects/${projectId}/tasks`,
      })
      return z.array(TaskSchema).parse(body.data)
    },
  })
}

// Глобальный список задач (экран /tasks): сотруднику — все задачи, заказчику —
// все задачи его сделок. Выполненные скрыты (open_only) — закрытие оптимистично
// убирает строку.
export function tasksQueryOptions() {
  return queryOptions({
    queryKey: taskKeys.lists,
    queryFn: async () => {
      const body = await apiRequest<{ items: unknown[] }>({
        method: 'GET',
        url: '/tasks',
        query: { open_only: true },
      })
      return z.array(TaskListItemSchema).parse(body.items)
    },
  })
}

export function taskDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: taskKeys.detail(id),
    queryFn: async () =>
      TaskReadSchema.parse(await apiRequest({ method: 'GET', url: `/tasks/${id}` })),
  })
}
